export default __webpack_public_path__ + "static/media/searchicon.66ea5ec3.svg";